var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeDOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlnsV: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 3.534a7.6 7.6 0 0 1 1.75-.2c5.833 0 9.167 6.667 9.167 6.667a15.41 15.41 0 0 1-1.8 2.658m-5.6-.892a2.5 2.5 0 0 1-1.785.795 2.5 2.5 0 0 1-1.812-.732 2.5 2.5 0 0 1-.732-1.812 2.5 2.5 0 0 1 .795-1.785m6.717 6.717A8.39 8.39 0 0 1 10 16.667C4.167 16.667.833 10 .833 10 1.87 8.068 3.308 6.381 5.05 5.05l9.9 9.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.833.833l18.333 18.333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeDOff);
export default __webpack_public_path__ + "static/media/eye-d-off.a6ad71f33a8acd569da1ced6e466e64c.svg";
export { ForwardRef as ReactComponent };